import createIcon from "./createIcon";

export const MinusIcon = createIcon('Minus', (props) => {
  return (
    <svg {...props} viewBox="0 0 16 16">
      <defs>
        <filter id="pixso_custom_mask_type_outline">
          <feColorMatrix 
            type="matrix" 
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" 
          />
        </filter>
      </defs>
      <mask 
        id="mask_4" 
        maskUnits="userSpaceOnUse"
        x="0" 
        y="0" 
        width="16" 
        height="16"
      >
        <g filter="url(#pixso_custom_mask_type_outline)">
          <rect 
            width="16" 
            height="16" 
            fill="currentColor"
          />
        </g>
      </mask>
      <g mask="url(#mask_4)">
        <path
          d="M3.33267 7.3335C2.96449 7.3335 2.66602 7.63197 2.66602 8.00016C2.66602 8.36835 2.96449 8.66683 3.33267 8.66683L3.33267 7.3335ZM12.666 8.66683L3.33301 8.66683L3.33301 7.3335L12.666 7.3335L12.666 8.66683ZM12.6664 8.66683C13.0344 8.66665 13.3327 8.36824 13.3327 8.00016C13.3327 7.63209 13.0344 7.33368 12.6664 7.3335L12.6664 8.66683Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </svg>
  )
});